export const chartTypes = {
  LINE: 'LINE',
  BAR: 'BAR',
  PIE: 'PIE',
  POSITIVE_NEGATIVE: 'PN',
  BRUSH_BAR: 'BRUSH_BAR',
};
